// const categories = [
//   "Electronics", "PCB", "Robotics", "Drone", "EV", "Automotive",
//   "Aerospace", "Medical Device", "Industrial", "Consumer",
//   "IoT", "3D Printing", "CNC", "Injection Moulding",
// ];

// export default function ProjectInfoStep({ formData, updateField }) {
//   return (
//     <div>
//       <div className="grid sm:grid-cols-2 gap-6 mb-6">
//         <label className="block">
//           <span className="block text-sm font-medium text-gray-700 mb-1.5">Project Name</span>
//           <input
//             value={formData.projectName}
//             onChange={(e) => updateField("projectName", e.target.value)}
//             placeholder="EV Battery Enclosure v3"
//             className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//           />
//         </label>

//         <label className="block">
//           <span className="block text-sm font-medium text-gray-700 mb-1.5">Expected Quantity</span>
//           <input
//             type="number"
//             value={formData.expectedQuantity}
//             onChange={(e) => updateField("expectedQuantity", e.target.value)}
//             placeholder="25"
//             className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//           />
//         </label>
//       </div>

//       <div className="mb-6">
//         <span className="block text-sm font-medium text-gray-700 mb-3">Category</span>
//         <div className="flex flex-wrap gap-2">
//           {categories.map((cat) => {
//             const isSelected = formData.category === cat;
//             return (
//               <button
//                 key={cat}
//                 type="button"
//                 onClick={() => updateField("category", cat)}
//                 className={`text-sm font-medium px-4 py-2 rounded-full border transition ${
//                   isSelected
//                     ? "bg-indigo-600 border-indigo-600 text-white"
//                     : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
//                 }`}
//               >
//                 {cat}
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       <label className="block mb-6">
//         <span className="block text-sm font-medium text-gray-700 mb-1.5">Description</span>
//         <textarea
//           value={formData.description}
//           onChange={(e) => updateField("description", e.target.value)}
//           placeholder="Describe your prototype and application..."
//           rows={4}
//           className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//         />
//       </label>

//       <label className="block">
//         <span className="block text-sm font-medium text-gray-700 mb-1.5">Target Delivery Date</span>
//         <input
//           type="date"
//           value={formData.targetDeliveryDate}
//           onChange={(e) => updateField("targetDeliveryDate", e.target.value)}
//           className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//         />
//       </label>
//     </div>
//   );
// }



import { useState } from "react";

const categories = [
 "Drone", "EV", "Automotive",
  "Aerospace", "Medical Device", "Industrial", "Consumer",
  "IoT", 
];

const industrySectors = [
  "AgriTech", "Aerospace", "Consumer", "Energy", "Defense",
  "Healthcare", "IoT", "Manufacturing", "Robotics", "Logistics"
];

const developmentStages = [
  "Design", "Working Prototype", "Production"
];

const budgetRanges = [
  "Below ₹50,000",
  "₹50,000 - ₹1,00,000",
  "₹1,00,000 - ₹5,00,000",
  "Above ₹5,00,000"
];

export default function ProjectInfoStep({ formData, updateField }) {
  const [showAdvanced, setShowAdvanced] = useState(false);

  return (
    <div>
      <div className="grid sm:grid-cols-2 gap-6 mb-6">
        <label className="block">
          <span className="block text-sm font-medium text-gray-700 mb-1.5">Project Name</span>
          <input
            value={formData.projectName}
            onChange={(e) => updateField("projectName", e.target.value)}
            placeholder="EV Battery Enclosure v3"
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
        </label>

        <label className="block">
          <span className="block text-sm font-medium text-gray-700 mb-1.5">Expected Quantity</span>
          <input
            type="number"
            value={formData.requiredQuantity}
            onChange={(e) => updateField("requiredQuantity", e.target.value)}
            placeholder="25"
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
        </label>
      </div>

      {/* Category */}
      <div className="mb-6">
        <span className="block text-sm font-medium text-gray-700 mb-3">Product Category</span>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => {
            const isSelected = formData.productCategory === cat;
            return (
              <button
                key={cat}
                type="button"
                onClick={() => updateField("productCategory", cat)}
                className={`text-sm font-medium px-4 py-2 rounded-full border transition ${
                  isSelected
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                }`}
              >
                {cat}
              </button>
            );
          })}
        </div>
      </div>

      {/* Description */}
      <label className="block mb-6">
        <span className="block text-sm font-medium text-gray-700 mb-1.5">Short Description</span>
        <textarea
          value={formData.shortDescription}
          onChange={(e) => updateField("shortDescription", e.target.value)}
          placeholder="Brief description of your prototype..."
          rows={3}
          className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        />
      </label>

      <label className="block mb-6">
        <span className="block text-sm font-medium text-gray-700 mb-1.5">Detailed Project Description</span>
        <textarea
          value={formData.detailedProjectDescription}
          onChange={(e) => updateField("detailedProjectDescription", e.target.value)}
          placeholder="Detailed description of your project, requirements, and specifications..."
          rows={4}
          className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        />
      </label>

      {/* Advanced Options Toggle */}
      <button
        type="button"
        onClick={() => setShowAdvanced(!showAdvanced)}
        className="text-sm font-medium text-indigo-600 hover:text-indigo-700 mb-4"
      >
        {showAdvanced ? "Hide Advanced Options" : "Show Advanced Options"}
      </button>

      {showAdvanced && (
        <div className="space-y-6 pt-4 border-t border-gray-100">
          {/* Industry Sector */}
          <div>
            <span className="block text-sm font-medium text-gray-700 mb-3">Industry Sector</span>
            <div className="flex flex-wrap gap-2">
              {industrySectors.map((sector) => {
                const isSelected = formData.industrySector === sector;
                return (
                  <button
                    key={sector}
                    type="button"
                    onClick={() => updateField("industrySector", sector)}
                    className={`text-sm font-medium px-4 py-2 rounded-full border transition ${isSelected
                        ? "bg-indigo-600 border-indigo-600 text-white"
                        : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                      }`}
                  >
                    {sector}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Development Stage */}
          <div>
            <span className="block text-sm font-medium text-gray-700 mb-3">Development Stage</span>
            <div className="flex flex-wrap gap-2">
              {developmentStages.map((stage) => {
                const isSelected = formData.developmentStage === stage;
                return (
                  <button
                    key={stage}
                    type="button"
                    onClick={() => updateField("developmentStage", stage)}
                    className={`text-sm font-medium px-4 py-2 rounded-full border transition ${isSelected
                        ? "bg-indigo-600 border-indigo-600 text-white"
                        : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                      }`}
                  >
                    {stage}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Budget Range */}
          <div>
            <span className="block text-sm font-medium text-gray-700 mb-3">Expected Budget Range</span>
            <div className="flex flex-wrap gap-2">
              {budgetRanges.map((range) => {
                const isSelected = formData.expectedBudgetRange === range;
                return (
                  <button
                    key={range}
                    type="button"
                    onClick={() => updateField("expectedBudgetRange", range)}
                    className={`text-sm font-medium px-4 py-2 rounded-full border transition ${isSelected
                        ? "bg-indigo-600 border-indigo-600 text-white"
                        : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                      }`}
                  >
                    {range}
                  </button>
                );
              })}
            </div>
          </div>

          <div style={{display:"flex",gap:"20px" }}>

            {/* Location */}
            {/* <label className="block" style={{flex:1}} >
              <span className="block text-sm font-medium text-gray-700 mb-1.5">Preferred Location</span>
              <input
                value={formData.preferredLocation}
                onChange={(e) => updateField("preferredLocation", e.target.value)}
                placeholder="Visakhapatnam, AP"
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </label> */}

            {/* Target Delivery Date */}
            <label className="block"  style={{flex:1}} >
              <span className="block text-sm font-medium text-gray-700 mb-1.5">Target Delivery Date</span>
              <input
                type="date"
                value={formData.targetDeliveryDate}
                onChange={(e) => updateField("targetDeliveryDate", e.target.value)}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </label>
             <label className="block"  style={{flex:1}} >
              {/* <span className="block text-sm font-medium text-gray-700 mb-1.5">Target Delivery Date</span>
              <input
                type="date"
                value={formData.targetDeliveryDate}
                onChange={(e) => updateField("targetDeliveryDate", e.target.value)}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              /> */}
            </label>
          </div>
        </div>
      )}
    </div>
  );
}